import { makeStyles } from "@mui/styles";

export const useStyles=makeStyles(({ palette, shape, transitions, breakpoints, spacing, typography }) => ({
    table:{
        "&.table .data-row td":{
            padding:spacing(1)
        }
    }
}));
